<script setup>
import { useRouter } from "vue-router";

defineProps({
  items: {
    type: Array,
    default: () => [],
  },
});

const router = useRouter();

const formatCurrency = (value) => {
  return new Intl.NumberFormat("th-TH", {
    style: "currency",
    currency: "THB",
    minimumFractionDigits: 0,
  }).format(value);
};
</script>
<template>
  <div class="card border-0 shadow-sm rounded-4 h-100">
    <div class="card-body p-4">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5 class="fw-bold mb-1">รายการค้างชำระ</h5>
          <div class="text-muted small">ยูนิตที่ยังไม่ชำระค่าส่วนกลาง</div>
        </div>

        <button
          class="btn btn-outline-warning btn-sm rounded-3"
          @click="router.push('/arrears')"
        >
          <i class="bi bi-check-lg me-1"></i>ตรวจสอบเพิ่มเติม
        </button>
      </div>

      <div class="table-responsive">
        <table class="table align-middle mb-0">
          <thead class="table-light">
            <tr>
              <th>ยูนิต</th>
              <th>ลูกบ้าน</th>
              <th>ค้างชำระ</th>
              <th class="text-end">ยอดค้าง</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in items"
              :key="`${item.unitNo}-${item.residentName}`"
            >
              <td class="fw-semibold">{{ item.unitNo }}</td>
              <td>{{ item.residentName }}</td>
              <td>
                <span class="badge text-bg-danger rounded-pill">
                  {{ item.overdueDays }} วัน
                </span>
              </td>
              <td class="text-end text-danger fw-semibold">
                {{ formatCurrency(item.amount) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
